import React from 'react'
import Box from '../atomic/Box'
import constants from '../constants'


const list = [
    {
        icon: constants.tabStar,
        title: "Aufgabe auswählen",
        description: "Wählen Sie die Aufgabe aus, die Sie ausführen möchten."
    },
    {
        icon: constants.starWhite,
        title: "Projekt benennen",
        description: "Vergeben Sie einen individuellen Namen."
    },
    {
        icon: constants.clip,
        title: "Dateien hinzufügen",
        description: "Fügen Sie Dateien zur Analyse hinzu."
    },
   
]
const HomeTabs = () => {
    return (
        <div className='bg-[#F5F7FB] p-7 flex gap-3 rounded-md'>
        {
            list.map((li, index) =>
                <div className='flex gap-2 flex-1 basis-0' key={index}>
                    <Box icon={li.icon} />
                    <div className='w-full'>
                        <h1 className='font-bold text-black'>{li.title}</h1>
                        <p className='text-custom-gray text-[10px] w-full'>{li.description}</p>
                    </div>
                </div>)
        }
    </div>
    )
}

export default HomeTabs